import { Component, OnInit, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { Observable } from 'rxjs';

import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { Vraag, Antwoord, Reparateur, Herstelbedrijf } from '@models/claims';
import { IBaseVraagboomResultaat, Meetgegevens, Verzekering, VraagboomAntwoord, VraagboomReparateurResultaat } from '@models/vragenboom';
import { DataService } from '../../../services/data.service';
import { MetenMapper } from '../../../mappers/meten.mapper';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-radiobutton-list-repair',
  templateUrl: './radiobutton-list-repair.component.html',
  styleUrls: ['./radiobutton-list-repair.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RadiobuttonListRepairComponent extends BaseVraagControlDirective<VraagboomReparateurResultaat> implements OnInit, OnChanges {
  selectedRelnr: string;
  selectedRol: string;
  _verzekering: Verzekering;
  _meetgegevens: Meetgegevens;
  resultaten$: Observable<VraagboomAntwoord<IBaseVraagboomResultaat>[]>;
  alleResultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[];
  reparateurs: Reparateur[] = [];
  constanteRelnrEigenReparateur = 'EIGENREPARATUER';

  constructor(_dataService: DataService) {
    super(_dataService);
  }

  ngOnInit() {
    this._verzekering = this._dataService.getVerzekering();
    this._meetgegevens = this._dataService.getMeetgegevens();
    this.resultaten$ = this._dataService.resultaten;
    this.resultaten$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        if (res !== undefined && res !== null) {
          this.alleResultaten = res;
        }
      });
  }

  initialize(changes: SimpleChanges): void {
    this.bepaalReparateurs();

    if (this.antwoordResultaat != null && this.antwoordResultaat.resultaat != null && this.antwoordResultaat.antwoorden != null) {
      this.selectedRelnr = this.antwoordResultaat.resultaat.relatienummer;
      this.selectedRol = this.antwoordResultaat.resultaat.rol;
    } else {
      this.selectedRelnr = '';
      this.selectedRol = '';
    }
  }

  radiobuttonClicked(relnr: string, rol: string): void {
    this.selectedRelnr = relnr;
    this.selectedRol = rol;

    if (this.vraag == null || this.vraag.antwoorden == null) {
      return;
    }
    if (relnr === this.constanteRelnrEigenReparateur) {
      // eigen reparateur gekozen
      this.voegAntwoordToe('', '', 1);
    } else {
      this.voegAntwoordToe(relnr, rol, 0);
    }
  }

  voegAntwoordToe(relnr: string, rol: string, index: number) {
    const antwoorden: Antwoord[] = [];
    if (this.vraag && this.vraag.antwoorden && this.vraag.antwoorden.length > index) {
      antwoorden.push(this.vraag.antwoorden[index]);
    }
    this.setAntwoord(antwoorden, new VraagboomReparateurResultaat(relnr, rol, '', '', true));
  }

  bepaalReparateurs() {
    this.reparateurs = [];

    this.vraag.antwoorden?.forEach((antwoord: Antwoord) => {
      if (antwoord.soortLijst?.herstelbedrijven) {
        let herstellers = antwoord.soortLijst.herstelbedrijven as Herstelbedrijf[];

        herstellers.forEach((hersteller: Herstelbedrijf) => {
          const reparateur = new Reparateur();
          reparateur.relnr = hersteller.relatienummer;
          reparateur.naam = hersteller.bedrijfsnaam;
          reparateur.adres = hersteller.straatOpgemaakt + ' ' + hersteller.plaatsOpgemaakt;
          reparateur.rol = hersteller.rol;
          this.reparateurs.push(reparateur);
        });
      } else {
        const reparateur = new Reparateur();
        reparateur.relnr = this.constanteRelnrEigenReparateur;
        reparateur.naam = antwoord.titel;
        reparateur.adres = antwoord.antwoordregels ? antwoord.antwoordregels[0] : '';
        this.reparateurs.push(reparateur);
      }
    });
  }

  stylingAntwoord(relnr: string): string {
    let klasse = '';
    if (this.selectedRelnr === relnr) {
      klasse = 'selected ';
    }
    return klasse;
  }

  geefMeetid(vraag: Vraag, reparateur: Reparateur): string {
    return 'ipoclick-radio-' + this._dataService.getMeetidPazaProces() + '-' +
      this._meetgegevens.status + this._meetgegevens.sleutel +
      MetenMapper.geefVolgnr(this.vraag, this._meetgegevens.reeks) + '_' +
      MetenMapper.format(vraag.titel) + '-' + MetenMapper.format(reparateur.naam);
  }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomReparateurResultaat): boolean {
    return true;
  }
}
